
<h1 mat-dialog-title>Textmuster erstellen</h1>

<mat-dialog-content class="custom-scrollbar w800">
  <form [formGroup]="textPatternFormGroup" class="pad-top8">
    <mat-form-field appearance="outline" class="w49 marg-right2">
      <mat-label>Name</mat-label>
      <input formControlName="nameCtrl" matInput placeholder="" required>
    </mat-form-field>
    <mat-form-field appearance="outline" class="w49">
      <mat-label>Fertigkeit</mat-label>
      <mat-select formControlName="mode">
        @for (option of modesList; track option) {
          <mat-option [value]="option">
            {{ formOptionsLists.modesToString.get(option) }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-dialog-close mat-raised-button>Abbrechen</button>
  <button (click)="createTextPattern()" [disabled]="textPatternFormGroup.controls.nameCtrl.hasError('required')"
          color="primary"
          mat-raised-button>Speichern
  </button>
</mat-dialog-actions>
